export default class Role {

  static readonly admin = `ADMIN`;
  static readonly developer = `DEVELOPER`;
  static readonly agent = `AGENT`;
  static readonly couponManger = `COUPON_MANAGER`;

};
